
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { getYourInformationResults } from "@/components/utils/PopulateForms/PopulateCommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { addressInfoType, contactInfoType } from '@/types/Application/CommonInformation';
import { urgencyInfoType } from '@/types/Application/ProtectionOrder/PDF';

@Component({
    components: {
        UnderlineForm,
        GreyBoxForm,
        CheckBox
    }
})
export default class CommonSection extends Vue {

    @Prop({ required: true })
    result!: any;

    otherPartyInfo = [];
    yourInfo = {} as yourInformationInfoDataInfoType;
    urgency = {} as urgencyInfoType;

    serviceAddress = {} as addressInfoType;
    serviceContact = {} as contactInfoType;

    existingFileNumber = '';
    orderType = '';
    dataReady = false;

    mounted() {
        this.dataReady = false;
        this.getServiceInfo();
        this.getOtherPartyInfo();
        this.getExistingFileNumber(this.result);
        this.yourInfo = this.getYourInfo()
        this.orderType = this.getOrderType();
        this.urgency = this.getUrgencyInfo();
        this.dataReady = true;
    }

    public getOrderType() {
        let orderType = ''
        if (this.result?.poQuestionnaireSurvey?.orderType)
            orderType = this.result?.poQuestionnaireSurvey?.orderType

        return orderType
    }

    public getUrgencyInfo() {

        let urgencyInfo = { PORNoNotice: '', PORWhyNoNotice: '' }

        if (this.result?.urgencySurvey) {
            urgencyInfo.PORNoNotice = this.result.urgencySurvey.PORNoNotice
            urgencyInfo.PORWhyNoNotice = this.result.urgencySurvey.PORWhyNoNotice
        }

        return urgencyInfo;
    }

    public getServiceInfo() {
        if (this.result?.yourinformationPOSurvey?.Lawyer == 'y') {
            this.serviceAddress = this.result.yourinformationPOSurvey.LawyerAddress
            this.serviceContact = this.result.yourinformationPOSurvey.LawyerContact
        } else if (this.result?.yourinformationPOSurvey) {
            this.serviceAddress = this.result.yourinformationPOSurvey.ApplicantAddress
            this.serviceContact = this.result.yourinformationPOSurvey.ApplicantContact
        }
    }

    public getOtherPartyInfo() {

        let info = []
        let dob = ''
        let name = ''
        let address = ''
        let contactInfo = ''
        let lawyer = ''

        if (this.result?.poQuestionnaireSurvey?.orderType == 'needPO') {

            if (this.result.protectionFromWhomSurvey?.RespondentDOBExact == 'y' && this.result.protectionFromWhomSurvey?.RespondentDOB)
                dob = this.result.protectionFromWhomSurvey.RespondentDOB

            if (this.result.protectionFromWhomSurvey?.RespondentName)
                name = this.result.protectionFromWhomSurvey.RespondentName

            if (this.result.protectionFromWhomSurvey?.RespondentAddress)
                address = this.result.protectionFromWhomSurvey.RespondentAddress

            if (this.result.protectionFromWhomSurvey?.RespondentContact)
                contactInfo = this.result.protectionFromWhomSurvey.RespondentContact

            info = [{ 'name': name, 'dob': dob, 'address': address, 'contact': contactInfo, 'lawyer': '' }]
        }
        else if (this.result.poQuestionnaireSurvey?.orderType == 'changePO' || this.result.poQuestionnaireSurvey?.orderType == 'terminatePO') {
            for (const party of this.result.otherPartySurvey) {
                dob = ''
                name = ''
                address = ''
                contactInfo = ''
                lawyer = ''

                if (party['knowDob'] == 'y' && party['dob'])
                    dob = party['dob']

                if (party['name'])
                    name = party['name']

                if (party['address'])
                    address = party['address']

                if (party['contactInfo'])
                    contactInfo = party['contactInfo']

                if (party['lawyer'])
                    lawyer = party['lawyer']

                info.push({ 'name': name, 'dob': dob, 'address': address, 'contact': contactInfo, 'lawyer': lawyer })
            }
        }
        else
            info = [{ 'name': { 'first': '', 'middle': '', 'last': '' }, 'address': '', 'contact': '', 'lawyer': '' }]

        this.otherPartyInfo = info
    }

    public getExistingFileNumber(result) {
        if (result.poQuestionnaireSurvey?.orderType) {
            const orderType = result.poQuestionnaireSurvey.orderType;
            if (orderType == 'needPO') {
                if (result.poFilingLocationSurvey?.ExistingFamilyCase == 'y' && result.poFilingLocationSurvey?.ExistingFileNumber) {
                    this.existingFileNumber = result.poFilingLocationSurvey.ExistingFileNumber;
                } else {
                    this.existingFileNumber = '';
                }
            } else if (orderType == 'changePO' || orderType == 'terminatePO') {
                if (result.aboutSurvey?.ExistingFileNumber) {
                    this.existingFileNumber = result.aboutSurvey.ExistingFileNumber;
                } else {
                    this.existingFileNumber = '';
                }
            }
        }
    }

    public getYourInfo() {

        if (this.result?.yourinformationPOSurvey) {
            return getYourInformationResults(this.result.yourinformationPOSurvey);
        }
        else
            return {} as yourInformationInfoDataInfoType;
    }

}
